import { useState, useEffect } from 'react'
import CustomerManageModal from './CustomerManageModal'
import './onLineService.less'
import SideToolBar from '../Layout/SideToolBar/SideToolBar'

interface PropTypes {
  userInfo: UserInfo | undefined
  flag?: boolean
  isInAdmin?: boolean,
  lang: Lang
  [propsName: string]: any
}

export default function OnLineService (props: PropTypes) {
  const { userInfo, flag, isInAdmin = false, lang = 'en' } = props

  const [visible, setVisible] = useState(false)

  const changeStatus = (value: boolean) => {
    setVisible(value)
  }

  const changeStatusAndFlag = () => {
    setVisible(false)
    if (props.changeFlag) {
      props.changeFlag(false)
    }
  }

  const handleShowOnlineService = () => {
    setVisible(true)
  }

  useEffect(() => {
    window.changeOnlineServiceVisible = changeStatus
  }, [])

  useEffect(() => {
    changeStatus(flag as boolean)
  }, [flag])

  return (
    <>
      {
        visible
          ? <CustomerManageModal userInfo={userInfo} changeStatusAndFlag={changeStatusAndFlag} />
          : <SideToolBar lang={lang} handleShowOnlineService={handleShowOnlineService} isInAdmin={isInAdmin} />
      }
    </>
  )
}
